import { fromJS } from 'immutable';
// - Import action types
import { NotificationActionType } from 'constants/notificationActionType';
// - Import actions
import * as globalActions from 'store/actions/globalActions';
import * as userActions from 'store/actions/userActions';
import { SocialProviderTypes } from 'src/core/socialProviderTypes';
import { provider } from 'src/socialEngine';
/**
 * Get service providers
 */
var notificationService = provider.get(SocialProviderTypes.NotificationService);
/* _____________ CRUD DB _____________ */
/**
 *  Add notificaition to database
 */
export var dbAddNotification = function (newNotify) {
    return function (dispatch, getState) {
        var notify = {
            isSeen: false,
            description: newNotify.description,
            url: newNotify.url,
            notifierUserId: newNotify.notifierUserId,
            notifyRecieverUserId: newNotify.notifyRecieverUserId
        };
        return notificationService.addNotification(notify)
            .then(function () {
            dispatch(addNotify());
        })
            .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
    };
};
/**
 * Get all notificaitions from database
 */
export var dbGetNotifications = function () {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        if (uid) {
            return notificationService.getNotifications(uid, function (notifications) {
                Object.keys(notifications).forEach((function (key) {
                    if (!state.getIn(['user', 'info', 'notifications', 'key', 'notifierUserId'])) {
                        dispatch(userActions.dbGetUserInfoByUserId(notifications[key].notifierUserId, ''));
                    }
                }));
                dispatch(addNotifyList(fromJS(notifications)));
            });
        }
    };
};
/**
 * Delete a notificaition from database
 * @param  {string} id of notificaition
 */
export var dbDeleteNotification = function (id) {
    return function (dispatch, getState) {
        // Get current user id
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        return notificationService.deleteNotification(id, uid).then(function () {
            dispatch(deleteNotify(id));
        })
            .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
    };
};
/**
 * Make seen a notificaition from database
 * @param  {string} id of notificaition
 */
export var dbSeenNotification = function (id) {
    return function (dispatch, getState) {
        var state = getState();
        var uid = state.getIn(['authorize', 'uid']);
        var notify = state.getIn(['notify', 'userNotifies', id]);
        var updatedNotification = {
            description: notify.get('description'),
            url: notify.get('url'),
            notifierUserId: notify.get('notifierUserId'),
            notifyRecieverUserId: uid,
            isSeen: true
        };
        return notificationService.setSeenNotification(id, uid, updatedNotification)
            .then(function () {
            dispatch(seenNotify(id));
        })
            .catch(function (error) { return dispatch(globalActions.showMessage(error.message)); });
    };
};
/* _____________ CRUD State _____________ */
/**
 * Add notificaition
 */
export var addNotify = function () {
    return {
        type: NotificationActionType.ADD_NOTIFY
    };
};
/**
 * Add notificaition list
 * @param {[notifyId: string]: Notification} userNotifies an array of notificaitions
 */
export var addNotifyList = function (userNotifies) {
    return {
        type: NotificationActionType.ADD_NOTIFY_LIST,
        payload: userNotifies
    };
};
/**
 * Delete a notificaition
 * @param  {string} id of notificaition
 */
export var deleteNotify = function (id) {
    return { type: NotificationActionType.DELETE_NOTIFY, payload: id };
};
/**
 * Change notificaition to has seen status
 * @param  {string} id of notificaition
 */
export var seenNotify = function (id) {
    return { type: NotificationActionType.SEEN_NOTIFY, payload: id };
};
/**
 * Clear all data
 */
export var clearAllNotifications = function () {
    return {
        type: NotificationActionType.CLEAR_ALL_DATA_NOTIFY
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/notifyActions.ts
// module id = 88
// module chunks = 50